import { render, staticRenderFns } from "./ArchiveOrders.vue?vue&type=template&id=5bdd3bc0&"
import script from "./ArchiveOrders.vue?vue&type=script&lang=js&"
export * from "./ArchiveOrders.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchiveOrders.vue"
export default component.exports